import { ActivityLogsBaseRequest } from './activity.logs.base.request';

export class MemberActivityLogsRequest extends ActivityLogsBaseRequest {

    MemberID: number;

}
